import { tokens } from './basicColors';
import { typography, fontWeight, fontSize } from './basicTypography';

export const getColorMap = (colors) => {
	let colorMap = {};
	Object.entries(colors).map(([, colorValues]) => {
		colorMap = { ...colorMap, ...colorValues };
		return null;
	});
	return colorMap;
};

// mui theme settings
export const themeSettings = (mode) => {
	const originalColors = tokens(mode);
	const colors = getColorMap(originalColors);
	return {
		breakpoints: {
			values: {
				xs: 0,
				sm: 768,
				md: 960,
				lg: 1200,
				xl: 1536,
			},
		},

		palette: {
			mode,
			...(mode === 'light'
				? {
						// palette values for light mode
						primary: {
							main: colors.blue[500],
							darker: '#35C37D',
						},
						secondary: {
							main: colors.purple[500],
						},
						error: {
							main: colors.pink[100],
						},
						neutral: {
							main: colors.white,
						},
						info: {
							main: colors.grey[700],
						},
						success: {
							main: colors.black,
						},
						setting: {
							main: colors.grey[700],
						},
						text: {
							primary: colors.grey[800],
							secondary: colors.grey[700],
							disabled: colors.grey[500],
						},
						background: {
							default: colors.white,
						},
				  }
				: {
						// palette values for dark mode
						primary: {
							main: colors.blue[500],
						},
						secondary: {
							main: colors.purple[500],
						},
						error: {
							main: colors.pink[100],
						},
						neutral: {
							main: colors.white,
						},
						info: {
							main: colors.grey[700],
						},
						success: {
							main: colors.black,
						},
						setting: {
							main: colors.grey[700],
						},
						text: {
							primary: colors.grey[800],
							secondary: colors.grey[700],
							disabled: colors.grey[500],
						},
						background: {
							default: colors.black,
						},
				  }),
		},
		components: {
			MuiButton: {
				styleOverrides: {
					root: ({ ownerState, theme }) => ({
						...(ownerState.variant === 'contained' &&
							ownerState.color === 'primary' && {
								'&:hover': {
									backgroundColor: theme.customColors.blue[600],
								},
								'&:active': {
									backgroundColor: theme.customColors.blue[600],
								},
							}),

						...(ownerState.variant === 'contained' &&
							ownerState.color === 'secondary' && {
								'&:hover': {
									backgroundColor: theme.customColors.purple[600],
								},
								'&:active': {
									backgroundColor: theme.customColors.purple[600],
								},
							}),
						...(ownerState.variant === 'contained' &&
							ownerState.color === 'error' && {
								color: theme.customColors.pink[600],
								'&:hover': {
									backgroundColor: theme.customColors.pink[300],
								},
								'&:active': {
									backgroundColor: theme.customColors.pink[300],
								},
							}),

						...(ownerState.variant === 'text' &&
							ownerState.color === 'primary' && {
								'&:hover': {
									backgroundColor: 'unset',
									color: theme.customColors.blue[600],
								},
							}),
						...(ownerState.variant === 'text' &&
							ownerState.color === 'secondary' && {
								'&:hover': {
									backgroundColor: 'unset',
									color: theme.customColors.purple[600],
								},
							}),
						...(ownerState.variant === 'text' &&
							ownerState.color === 'info' && {
								'&:hover': {
									backgroundColor: 'unset',
									color: theme.customColors.grey[600],
								},
							}),
						...(ownerState.variant === 'outlined' &&
							ownerState.color === 'primary' && {
								'&:hover': {
									color: theme.customColors.white,
									backgroundColor: theme.customColors.blue[600],
									borderColor: theme.customColors.blue[600],
								},
							}),
						...(ownerState.variant === 'outlined' &&
							ownerState.color === 'secondary' && {
								'&:hover': {
									color: theme.customColors.white,
									backgroundColor: theme.customColors.purple[600],
									borderColor: theme.customColors.purple[600],
								},
							}),

						...(ownerState.variant === 'outlined' &&
							ownerState.color === 'error' && {
								color: theme.customColors.pink[600],
								borderColor: theme.customColors.pink[600],
								'&:hover': {
									color: theme.customColors.white,
									backgroundColor: theme.customColors.pink[600],
									borderColor: theme.customColors.pink[600],
								},
							}),
					}),
				},
			},
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						lineHeight: '1.15',
					},
					// '& .MuiGrid-spacing-xs-1': {
					// 	'& > .MuiGrid-item': {
					// 		padding: 0,
					// 	},
					// },
				},
			},
		},
		typography: typography(),
		fontWeight,
		fontSize,
		customColors: {
			...colors,
		},
		borderRadius: {
			radiusNormal: '3px',
			radiusMedium: '5px',
			radiusLarge: '8px',
		},
	};
};
